
const API_ROOT = 'https://app-node.talkfintech.com:3016';
// const API_ROOT = 'https://app-node-talkfintech.ondotmail.com:3015';

//  const root_data = "https://talkfintech.ondotmail.com/updatedPostData/postData.json";

const webPath = 'https://talkfintech.com'

export { API_ROOT , webPath};